import { Reveal } from "@/components/Reveal";
import { homeStatement } from "@/lib/siteConfig";

// Full-width parallax statement band. Gentle fixed-attachment drift on desktop,
// normal scroll on mobile. Real HTML text over a darkened photographic layer.
export const ParallaxStatement = () => {
  const s = homeStatement;
  return (
    <section
      className="az-parallax relative isolate overflow-hidden"
      style={{ backgroundImage: `url(${s.image})` }}
      data-testid="home-parallax-statement"
      aria-label={s.title}
    >
      {/* Neutral darkening only – the photo keeps its natural colours */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(12,16,20,0.72) 0%, rgba(12,16,20,0.6) 50%, rgba(12,16,20,0.76) 100%)",
        }}
      />
      <div className="relative az-container py-24 text-center lg:py-32">
        <Reveal>
          <span className="az-eyebrow justify-center" style={{ color: "#C99A3D" }}>
            <span className="inline-block h-px w-6 bg-current" />
            {s.eyebrow}
          </span>
        </Reveal>
        <Reveal delay={0.06}>
          <h2 className="mx-auto mt-5 max-w-4xl font-heading text-4xl font-semibold leading-[1.12] tracking-[-0.01em] text-[#F1F4F8] sm:text-5xl lg:text-[3.4rem]">
            {s.title}
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-[rgba(244,246,249,0.82)] sm:text-xl">
            {s.text}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
